// import { useEffect, useState } from 'react';
// import api from '../api';

// const currentYear = new Date().getFullYear();
// const currentMonth = new Date().getMonth() + 1;

// const years = [];
// for (let y = currentYear - 2; y <= currentYear + 1; y++) years.push(y);

// const months = [
//   { value: 1, label: 'Jan' },
//   { value: 2, label: 'Feb' },
//   { value: 3, label: 'Mar' },
//   { value: 4, label: 'Apr' },
//   { value: 5, label: 'May' },
//   { value: 6, label: 'Jun' },
//   { value: 7, label: 'Jul' },
//   { value: 8, label: 'Aug' },
//   { value: 9, label: 'Sep' },
//   { value: 10, label: 'Oct' },
//   { value: 11, label: 'Nov' },
//   { value: 12, label: 'Dec' },
// ];

// const PayslipList = () => {
//   const [year, setYear] = useState(currentYear);
//   const [month, setMonth] = useState(currentMonth);
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [emailSendingId, setEmailSendingId] = useState(null);
//   const [sendingAll, setSendingAll] = useState(false);

//   const load = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get('/payroll', { params: { year, month } });
//       setRows(res.data);
//     } catch (err) {
//       console.error(err);
//       alert('Error loading payslips');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     load();
//   }, []); // initial

//   const handleFilter = () => {
//     load();
//   };

//   const handleSendEmail = async (id) => {
//     setEmailSendingId(id);
//     try {
//       await api.post(`/payroll/${id}/email`);
//       await load();
//     } catch (err) {
//       console.error(err);
//       alert('Error sending email');
//     } finally {
//       setEmailSendingId(null);
//     }
//   };

//   const handleSendAll = async () => {
//     if (!window.confirm('Send payslip email to all employees for this month?')) return;
//     setSendingAll(true);
//     try {
//       await api.post('/payroll/email-all', { year, month });
//       await load();
//     } catch (err) {
//       console.error(err);
//       alert('Error sending emails to all');
//     } finally {
//       setSendingAll(false);
//     }
//   };

//   const monthLabel = months.find((m) => m.value === Number(month))?.label || month;

//   return (
//     <div className="card">
//       <div className="card-header">
//         <h2>Payslips</h2>
//         <button
//           className="btn btn-primary"
//           onClick={handleSendAll}
//           disabled={sendingAll || rows.length === 0}
//         >
//           {sendingAll ? 'Sending to All...' : 'Send Email to All'}
//         </button>
//       </div>

//       <div className="filter-row">
//         <select value={month} onChange={(e) => setMonth(Number(e.target.value))}>
//           {months.map((m) => (
//             <option key={m.value} value={m.value}>
//               {m.label}
//             </option>
//           ))}
//         </select>
//         <select value={year} onChange={(e) => setYear(Number(e.target.value))}>
//           {years.map((y) => (
//             <option key={y} value={y}>
//               {y}
//             </option>
//           ))}
//         </select>
//         <button className="btn btn-secondary" onClick={handleFilter} disabled={loading}>
//           {loading ? 'Loading...' : 'Apply'}
//         </button>
//       </div>

//       {rows.length === 0 ? (
//         <p className="text-muted">
//           No payslips for {monthLabel} {year}. Upload the payroll Excel first.
//         </p>
//       ) : (
//         <table className="table">
//           <thead>
//             <tr>
//               <th>Emp Code</th>
//               <th>Name</th>
//               <th>Net Pay</th>
//               <th>PDF</th>
//               <th>Email Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {rows.map((r) => (
//               <tr key={r.id}>
//                 <td>{r.emp_code}</td>
//                 <td>
//                   {r.first_name} {r.last_name}
//                 </td>
//                 <td>{Number(r.net_pay).toLocaleString('en-IN')}</td>
//                 <td>
//                   {/* Download triggers on-demand PDF generation */}
//                   <a
//                     href={`http://localhost:4000/api/payroll/${r.id}/download`}
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     Download
//                   </a>
//                 </td>
//                 <td>
//                   {r.email_status === 'SENT' ? (
//                     <span className="badge badge-success">Sent</span>
//                   ) : r.email_status === 'FAILED' ? (
//                     <span className="badge badge-warning">Failed</span>
//                   ) : (
//                     <span className="badge badge-warning">Pending</span>
//                   )}
//                 </td>
//                 <td>
//                   <button
//                     className="btn btn-primary"
//                     onClick={() => handleSendEmail(r.id)}
//                     disabled={emailSendingId === r.id}
//                   >
//                     {emailSendingId === r.id
//                       ? 'Sending...'
//                       : r.email_status === 'SENT'
//                       ? 'Resend Email'
//                       : 'Send Email'}
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default PayslipList;








import { useEffect, useState } from "react";
import api from "../api";

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;

const years = [];
for (let y = currentYear - 2; y <= currentYear + 1; y++) years.push(y);

const months = [
  { value: 1, label: "Jan" },
  { value: 2, label: "Feb" },
  { value: 3, label: "Mar" },
  { value: 4, label: "Apr" },
  { value: 5, label: "May" },
  { value: 6, label: "Jun" },
  { value: 7, label: "Jul" },
  { value: 8, label: "Aug" },
  { value: 9, label: "Sep" },
  { value: 10, label: "Oct" },
  { value: 11, label: "Nov" },
  { value: 12, label: "Dec" },
];

const PayslipList = () => {
  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [emailSendingId, setEmailSendingId] = useState(null);
  const [sendingAll, setSendingAll] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 10;

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/payroll", { params: { year, month } });
      setRows(res.data);
    } catch (err) {
      console.error(err);
      alert("Error loading payslips");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []); // initial load

  useEffect(() => {
    setPage(1);
  }, [rows, month, year]);

  const handleFilter = () => {
    load();
  };

  const handleSendEmail = async (id) => {
    setEmailSendingId(id);
    try {
      await api.post(`/payroll/${id}/email`);
      await load();
    } catch (err) {
      console.error(err);
      alert("Error sending email");
    } finally {
      setEmailSendingId(null);
    }
  };

  const handleSendAll = async () => {
    if (
      !window.confirm(
        "Send payslip email to all employees for this month?"
      )
    )
      return;
    setSendingAll(true);
    try {
      await api.post("/payroll/email-all", { year, month });
      await load();
    } catch (err) {
      console.error(err);
      alert("Error sending emails to all");
    } finally {
      setSendingAll(false);
    }
  };

  const monthLabel =
    months.find((m) => m.value === Number(month))?.label || month;

  const totalPages = Math.max(1, Math.ceil((rows?.length || 0) / pageSize));
  const paginatedRows = rows.slice((page - 1) * pageSize, page * pageSize);

  return (
    <div className="payslips-shell">
      {/* Header */}
      <div className="payslips-header">
        <div>
          <h1 className="payslips-title">Payslips</h1>
          <p className="payslips-subtitle">
            View, download, and email payslips generated from monthly payroll.
          </p>
        </div>
        <div className="payslips-header-right">
          <div className="payslips-period-chip">
            <span>Period</span>
            <strong>
              {monthLabel} {year}
            </strong>
          </div>
          <button
            className="btn-primary-large"
            onClick={handleSendAll}
            disabled={sendingAll || rows.length === 0}
          >
            {sendingAll ? "Sending to All…" : "Send Email to All"}
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="payslips-filters">
        <div className="payslips-filter-group">
          <label className="payslips-filter-label">Month</label>
          <select
            className="payslips-select"
            value={month}
            onChange={(e) => setMonth(Number(e.target.value))}
          >
            {months.map((m) => (
              <option key={m.value} value={m.value}>
                {m.label}
              </option>
            ))}
          </select>
        </div>

        <div className="payslips-filter-group">
          <label className="payslips-filter-label">Year</label>
          <select
            className="payslips-select"
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
          >
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>

        <button
          className="btn-secondary"
          onClick={handleFilter}
          disabled={loading}
        >
          {loading ? "Loading…" : "Apply"}
        </button>
      </div>

      {/* Table / content */}
      <div className="payslips-card">
        {rows.length === 0 ? (
          <div className="payslips-empty">
            <p>
              No payslips for <strong>{monthLabel}</strong> {year}. Upload the
              payroll Excel for this period under{" "}
              <span className="pill-subtle">Payroll Upload</span>.
            </p>
          </div>
        ) : (
          <div className="payslips-table-wrapper">
            <table className="payslips-table">
              <thead>
                <tr>
                  <th>Emp Code</th>
                  <th>Name</th>
                  <th>Net Pay</th>
                  <th>PDF</th>
                  <th>Email Status</th>
                  <th style={{ width: 150 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginatedRows.map((r) => (
                  <tr key={r.id}>
                    <td className="payslips-emp-code">{r.emp_code}</td>
                    <td>
                      <span className="payslips-name">
                        {r.first_name} {r.last_name}
                      </span>
                    </td>
                    <td>₹{Number(r.net_pay).toLocaleString("en-IN")}</td>
                    <td>
                      <a
                        href={`/api/payroll/${r.id}/download`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-chip"
                      >
                        Download
                      </a>
                    </td>
                    <td>
                      {r.email_status === "SENT" ? (
                        <span className="badge-status badge-status-success">
                          Sent
                        </span>
                      ) : r.email_status === "FAILED" ? (
                        <span className="badge-status badge-status-failed">
                          Failed
                        </span>
                      ) : (
                        <span className="badge-status badge-status-pending">
                          Pending
                        </span>
                      )}
                    </td>
                    <td>
                      <button
                        className="btn-chip"
                        onClick={() => handleSendEmail(r.id)}
                        disabled={emailSendingId === r.id}
                      >
                        {emailSendingId === r.id
                          ? "Sending…"
                          : r.email_status === "SENT"
                          ? "Resend Email"
                          : "Send Email"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pagination-row">
              <button
                className="btn-secondary"
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
              >
                Prev
              </button>
              <span className="pagination-text">
                Page {page} of {totalPages}
              </span>
              <button
                className="btn-secondary"
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PayslipList;
